import {
    
    Carousel,
} from "@peracto/peracto-blocks-tailwind";

import Products from "./KooltechProducts";

export default {
    plugins: {
        content: [Carousel,  Products],
    },
};
